import React, { useState }from 'react';
import { useSelector, useDispatch } from "react-redux";
import { resetPagination } from 'reducers/paginationEmployeesSlice';
import { setFilters,resetFilters } from 'reducers/filtersDriversSlice'; 
import DashboardIcon from '@mui/icons-material/Dashboard';
import FeedIcon from '@mui/icons-material/Feed';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings'; 
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import { ToastContainer } from 'react-toastify'; 
import { TodayIs} from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Person from 'pages/main/Person';
import Messages from 'pages/messages/Messages';
import ColorSettings  from "pages/settings/ColorSettings";
import RoadSettings  from "pages/settings/RoadSettings";
import DocumentTypeSettings from "pages/settings/DocumentTypeSettings";
import LanguageSettings from "pages/settings/LanguageSettings";
import CountrySettings from "pages/settings/CountrySettings";
import CommunitySettings from "pages/settings/CommunitySettings"
import DriversFilter from "pages/driver/driversFilterList/DriverFilter"; 
 
const HomeDriver = () => {
    const {t,i18n} = useTranslation(['listDataEmployees']);
    const dispatch = useDispatch();
    const filtersDriversDetails = useSelector((state) => state.filtersDrivers); // Obtener filtros desde Redux
    const enabled = useSelector((state) => state.loginUser.enabled);
    const roles = useSelector((state) => state.loginUser.roles);  
    const defaultStore = useSelector((state) => state.loginUser.defaultStore)
    const [showModalGeneralSettings, setShowModalGeneralSettings] = useState(false);
    const [indexShowSettings,setIndexShowSettings]=useState(0);
    const [showModalColorSettings, setShowModalColorSettings] = useState(false);
    const [showDocumentTypeSettings, setShowModalDocumentTypeSettings] = useState(false);
    const [showCommunitySettings, setShowCommunitySettings] = useState(false);
    const [showLanguageSettings, setShowModalLanguageSettings] = useState(false);
    const [showRoadSettings, setShowModalRoadSettings] = useState(false);
    const [showCountrySettings, setShowModalCountrySettings] = useState(false);
    const [showModalEmployeeSettings, setShowModalEmployeeSettings] = useState(false); 
    const [showModalDriverSettings, setShowModalDriverSettings] = useState(true);
    const [showModalStoreSettings, setShowModalStoreSettings] = useState(false); 
    const [showModalFormSettings, setShowModalFormSettings] = useState(false);  
    const [showModalTicketsSettings, setShowModalTicketsSettings] = useState(false); 
    const [showModalContractSettings, setShowModalContractSettings] = useState(false); 
    const [showModalArticlesSettings, setShowModalArticlesSettings] = useState(false); 
    const [showModalPurchasesDeliverySettings, setShowModalPurchasesDeliverySettings] = useState(false); 
    const [showModalShippingsSettings, setShowModalShippingsSettings] = useState(false); 
    const [showModalRegisterBookSettings, setShowModalRegisterBookSettings] = useState(false); 
    const [showModalNTSettings, setShowModalNTSettings] = useState(false); 
    const scriptUrl = '/js/sb-admin-2.min.js'; 
 
     const changeSelectedLanguage = () => {
        if (i18n.language === "es") {
            i18n.changeLanguage("en");
            dispatch(setFilters({ languageFromES: "", languageToES: "" }));
        } else {
            i18n.changeLanguage("es");
            dispatch(setFilters({ languageFromEN: "", languageToEN: "" }));
        }
    };

    const closeModalDrives = () => {     
        setShowModalGeneralSettings(false);
        setIndexShowSettings(0);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(true);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalNTSettings(showModalNTSettings); 
        setShowModalLanguageSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(showModalEmployeeSettings);
        setShowModalDriverSettings(showModalDriverSettings);
        setShowModalFormSettings(showModalFormSettings);
        setShowModalTicketsSettings(false);
        setShowModalTicketsSettings(showModalTicketsSettings);
        setShowModalStoreSettings(showModalStoreSettings);
        setShowModalContractSettings(showModalContractSettings);
        setShowModalArticlesSettings(showModalArticlesSettings);
        setShowModalPurchasesDeliverySettings(showModalPurchasesDeliverySettings);
        setShowModalShippingsSettings(showModalShippingsSettings);
        setShowModalRegisterBookSettings(showModalRegisterBookSettings);
        dispatch(resetPagination());
        dispatch(resetFilters());
        return () => {};
    };
   
    function openModaColorsSettings(){
        setIndexShowSettings(1);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(true);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalNTSettings(false);
        setShowModalLanguageSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(showModalFormSettings);
        setShowModalTicketsSettings(false);
        setShowModalStoreSettings(showModalStoreSettings);
        setShowModalContractSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false);
        setShowModalGeneralSettings(showModalGeneralSettings);
    } 

    function openModaDocuemntsSettings(){
        setIndexShowSettings(2);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalDocumentTypeSettings(true);
        setShowCommunitySettings(false);
        setShowModalNTSettings(false);
        setShowModalLanguageSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalTicketsSettings(false);
        setShowModalStoreSettings(false);
        setShowModalContractSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false);
        setShowModalGeneralSettings(showModalGeneralSettings);
    }

    function openModaLanguageSettings(){
        setIndexShowSettings(3);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalNTSettings(false);
        setShowModalLanguageSettings(true);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalTicketsSettings(false);
        setShowModalStoreSettings(false);
        setShowModalContractSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false);
        setShowModalGeneralSettings(showModalGeneralSettings);
    }

    function openModaCountrySettings(){
        setIndexShowSettings(4);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalNTSettings(false);
        setShowModalLanguageSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(true);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalTicketsSettings(false);
        setShowModalStoreSettings(false);
        setShowModalContractSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false);
        setShowModalGeneralSettings(showModalGeneralSettings);
    }

    function openModaRoadSettings(){
        setIndexShowSettings(5);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalNTSettings(false);
        setShowModalLanguageSettings(false);
        setShowModalRoadSettings(true);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalTicketsSettings(false);
        setShowModalStoreSettings(false);
        setShowModalContractSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false);
        setShowModalGeneralSettings(showModalGeneralSettings);
    }

    function openModaCommunitySettings(){
        setIndexShowSettings(6);
        setIndexShowSettings(indexShowSettings);
        setShowModalColorSettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(true);
        setShowModalNTSettings(false);
        setShowModalLanguageSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalTicketsSettings(false);
        setShowModalStoreSettings(false);
        setShowModalContractSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false);
        setShowModalGeneralSettings(showModalGeneralSettings);
    }
          
    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer/>
        {enabled===false ? <Navigate to="/"></Navigate>:
        <div id="page-top">
           
            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary toggled sidebar sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main_Driver')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION FILTROS APLICADOS */}
                    <li className="nav-item active">
                        <Link className="nav-link" to="/driver">
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li>
                    <div className={filtersDriversDetails.idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_From')}
                    </div>
                    <li className={filtersDriversDetails.idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.idFrom==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.idFrom}
                    </li>
                    <div className={filtersDriversDetails.idTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_To')}
                    </div>
                    <li className={filtersDriversDetails.idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.idTo==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.idTo}
                    </li>
                    <div className={filtersDriversDetails.firstnameFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_firstname_From')}
                    </div>
                    <li className={filtersDriversDetails.firstnameFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.firstnameFrom==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.firstnameFrom}
                    </li>
                    <div className={filtersDriversDetails.firstnameTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_firstname_To')}
                    </div>
                    <li className={filtersDriversDetails.firstnameTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.firstnameTo==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.firstnameTo}
                    </li>

                    <div className={filtersDriversDetails.lastname1From===''?"sidebar-heading":"sidebar-heading text-white"}> 
                        {t('Text_Filter_lastname1_From')}
                    </div>
                    <li className={filtersDriversDetails.lastname1From===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.lastname1From==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.lastname1From}
                    </li>
                    <div className={filtersDriversDetails.lastname1To===''?"sidebar-heading":"sidebar-heading text-white"}> 
                        {t('Text_Filter_lastname1_To')}
                    </div>
                    <li className={filtersDriversDetails.lastname1To===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.lastname1To==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.lastname1To}
                    </li>

                    <div className={filtersDriversDetails.lastname2From===''?"sidebar-heading":"sidebar-heading text-white"}> 
                        {t('Text_Filter_lastname2_From')}
                    </div>
                    <li className={filtersDriversDetails.lastname2From===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.lastname2From==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.lastname2From}
                    </li>
                    <div className={filtersDriversDetails.lastname2To===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_lastname2_To')}
                    </div>
                    <li className={filtersDriversDetails.lastname2To===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.lastname2To==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.lastname2To}
                    </li>
                    <div className={filtersDriversDetails.emailsFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_emails_From')}
                    </div>
                    <li className={filtersDriversDetails.emailsFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.emailsFrom==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.emailsFrom}
                    </li>
                    <div className={filtersDriversDetails.emailsTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_emails_To')}
                    </div>
                    <li className={filtersDriversDetails.emailsTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.emailsTo==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.emailsTo}
                    </li>
                    <div className={filtersDriversDetails.phonesFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_phones_From')}
                    </div>
                    <li className={filtersDriversDetails.phonesFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.phonesFrom==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.phonesFrom}
                    </li>
                    <div className={filtersDriversDetails.phonesTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_phones_To')}
                    </div>
                    <li className={filtersDriversDetails.phonesTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersDriversDetails.phonesTo==='' ? t('Text_Filter_Not_Apply'): filtersDriversDetails.phonesTo}
                    </li>
                    
                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    <div className={!filtersDriversDetails.enabled?"sidebar-heading":"sidebar-heading text-white"}>
                        <i className="fas fa-solid fa-circle" style={{color:(filtersDriversDetails.enabled)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_Habilty')}
                    </div>
                    <div className={!filtersDriversDetails.notenabled?"sidebar-heading":"sidebar-heading text-white"}>
                        <i className="fas fa-solid fa-circle" style={{color:(filtersDriversDetails.notenabled)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_Not_Habilty')}
                    </div>
                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings"))&&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/driver" data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                    
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Colors"))&&
                                    <Link className="collapse-item"  to="/driver" onClick={openModaColorsSettings}>{t('SubMenu_Settings_Type_Colors')} </Link> }
                                    
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Docuemnts"))&&
                                    <Link className="collapse-item"  to="/driver" onClick={openModaDocuemntsSettings}>{t('SubMenu_Settings_Type_Documents')} </Link>}
                                    
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Languages"))&&
                                    <Link className="collapse-item"  to="/driver" onClick={openModaLanguageSettings}>{t('SubMenu_Settings_Type_Languages')} </Link>}
                                    
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Locations"))&&
                                    <Link className="collapse-item"  to="/driver" onClick={openModaCountrySettings}>{t('SubMenu_Settings_Type_Locations')} </Link>}
                                   
                                   {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Roads"))&&
                                    <Link className="collapse-item"  to="/driver" onClick={openModaRoadSettings}>{t('SubMenu_Settings_Type_Roads')} </Link>}
                                 
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Community"))&&
                                    <Link className="collapse-item"  to="/driver" onClick={openModaCommunitySettings}>{t('SubMenu_Settings_Type_Community')} </Link>}
                                  
                                    <Link className="collapse-item" to="/driver" onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                   
                                </div>
                            </div>
                        </li>
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/home" onClick={closeModalDrives}>
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                            <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="driver-name-ok">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>   
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}

                {/* Show Modals */}  
                <DriversFilter 
                    showModalDriverSettings={showModalDriverSettings}
                    setShowModalDriverSettings={setShowModalDriverSettings}  
                />
                <ColorSettings  
                    showModalColorSettings={showModalColorSettings}
                    setShowModalColorSettings={setShowModalColorSettings}
                    setIndexShowSettings={setIndexShowSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings}
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={true}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false}
                    
                />
                <CommunitySettings  
                    showCommunitySettings={showCommunitySettings} 
                    setShowCommunitySettings={setShowCommunitySettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={true}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalTicketsSettings={setShowModalTicketsSettings}
                    isWweigVehicles={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                />
                <DocumentTypeSettings  
                    showDocumentTypeSettings={showDocumentTypeSettings}
                    setShowModalDocumentTypeSettings={setShowModalDocumentTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={true}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalTicketsSettings={setShowModalTicketsSettings}
                    isWweigVehicles={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                />
                <LanguageSettings  
                    showLanguageSettings={showLanguageSettings} 
                    setShowModalLanguageSettings={setShowModalLanguageSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={true}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                />
                <RoadSettings  
                    showRoadSettings={showRoadSettings} 
                    setShowModalRoadSettings={setShowModalRoadSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={true}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalTicketsSettings={setShowModalTicketsSettings}
                    isWweigVehicles={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                />
                <CountrySettings  
                    showCountrySettings={showCountrySettings} 
                    setShowModalCountrySettings={setShowModalCountrySettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={true}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                     setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalTicketsSettings={setShowModalTicketsSettings}
                    isWweigVehicles={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                /> 
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         
      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomeDriver;
